import type { ContratProADTO } from '@/features/api/extranet/dto/Demande/PROA'

export function getDocumentsObligatoires(_proa: ContratProADTO): string[] {
  const documentsObligatoires: string[] = ['Cerfa', 'Convention']
  return documentsObligatoires
}

export function getDocumentsFacultatifs(_proa: ContratProADTO): string[] {
  const documentsFacultatifs: string[] = ['Autre']

  return documentsFacultatifs
}
